module.exports = "i, cite, em, var, address, dfn{\n    font-style: normal !important;\n}\nspan.notification{\n    vertical-align: top !important;\n}\n.boldText{\n    font-weight: bold !important;\n}\n.normalText{\n    font-weight: unset !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/side-menu/side-menu.component.css
// module id = ./src/app/components/side-menu/side-menu.component.css
// module chunks = main